/*
 Convention: https://docs.google.com/document/d/1ePqfM41II2CNBYpTuOgjLZafRkn6vABQ5NF40JGER1E/edit
 Review Reference: https://docs.google.com/document/d/1Diu8ZwKXPOWCsH2ry8rufCYADGFcHtR4MY3k1c3Ypes/edit

 ! Review
 TODO Dashboard - change to ts
 */
import { defaultAction } from '../types';

const initialState = {
  balance: 0,
};

const accountStatementReducer = (
  state = initialState,
  action = defaultAction,
) => {
  switch (action.type) {
    case 'SET_BALANCE':
      return {
        ...state,
        balance: action.payload,
      };
    default:
      return state;
  }
};

export default accountStatementReducer;
